import styled from "styled-components";

export const Wrapper = styled.div`
  @media print {
    padding-right: 14px;
  }

  .data-table {
    margin-top: 26px;
    margin-left: 50px;
    width: 742px;
    max-width: 742px;

    @media print {
      margin-left: 38px;
    }

    .row {
      background: #fafafa;
      padding: 8px 0;
      color: #aaebd;

      @media print {
        padding: 2px 0;
      }

      &:first-child {
        padding-top: 26px;

        @media print {
          padding-top: 18px;
        }

        .column:first-child {
          color: ${props => props.theme.blueLight};
        }
      }

      &:nth-child(2) {
        padding-bottom: 26px;

        @media print {
          padding-bottom: 18px;
        }

        .column:first-child {
          color: ${props => props.theme.blueDark};
        }
      }

      .column:first-child {
        width: 90px;
        max-width: 90px;
        text-align: right;
        padding-left: 2px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .column:not(:first-child) {
        width: 93px;
        max-width: 93px;
        padding-left: 37px;
        text-align: left;
        position: relative;
      }

      .column {
        font-size: 14px;
        padding: 0 4px;

        svg {
          font-size: 16px;
          position: absolute;
          top: 1px;
          left: 20px;
        }
      }

      .no-data {
        position: absolute;
        top: -27px;
        left: 0;
        z-index: 1000;
        padding: 0 20px;
        font-size: 12px;
        text-align: center;
        line-height: 15px;
        color: #555;
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/MagnetReport/components/AllDomainsGraph/style.js